import './index.scss';

import myData from '../../db.json';
import momentStudioPng from '../../assets/static/images/images.png';
import momentStudioLogo from '../../assets/static/images/logo.png';

const yugacrewSvg = '/assets/images/yugacrew.svg';
const yugacrewPng = '/assets/images/yugacrew-image.png';
const threeHoursAgoSvg = '/assets/images/3ha-logo_full.svg';

const CareerItem = ({ item }) => {
  return (
    <div className={`career-layout career-layout--summary-only ${item.company === '모먼트스튜디오' ? 'career-layout--moment' : 'career-layout--yugacrew'}`}>
      <div className='career-summary'>
        <figure className='company-badge'>
          <img 
            src={item.company === '육아크루' ? yugacrewPng : item.company === '모먼트스튜디오' ? momentStudioLogo : momentStudioPng} 
            alt={`${item.company} 서비스 이미지`} 
          />
        </figure>
        <div className='career-heading'>
          <div className='career-heading-content'>
            <div className='career-title-row'>
              <h2>
                {item.company === '육아크루' ? (
                  <img src={yugacrewSvg} alt={item.company} className='company-logo-text' />
                ) : item.company === '모먼트스튜디오' ? (
                  <span className='company-text-logo'>
                    <img src={threeHoursAgoSvg} alt={item.service || '세시간전'} className='company-logo-text' />
                  </span>
                ) : (
                  <span className='company-text-logo'>
                    <span>{item.company}</span>
                    {item.service && (
                      <>
                        <span className='company-text-divider'> / </span>
                        <span className='company-service-highlight' style={item.brandColor ? { color: item.brandColor } : undefined}>
                          {item.service}
                        </span>
                      </>
                    )}
                  </span>
                )}
              </h2>
            </div>
            <div className='career-meta'>
              {item.role?.split(', ').map((r) => <p key={r}>{r}</p>)}
              <p>{item.term}</p>
              {item.contribution && <p>기여도: {item.contribution}</p>}
            </div>
            {item.description && (
              <p className='career-description'>{item.description}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const Career = () => {
  const { career } = myData;

  return (
    <section className='career-section'>
      <p className='section-label'>{career.sectionLabel}</p>

      <div className='career-list'>
        {career.list.map((item) => (
          <CareerItem key={`${item.company}-${item.term}`} item={item} />
        ))}
      </div>
    </section>
  );
};

export default Career;
